/**
 * Dialer Tour Configuration
 * Interactive demo of the All-in-One Dialer showing Manual, Power, Multi-Line and InsuraBot
 * Uses DialerTourDemo component for 1:1 simulation without touching real Twilio
 */

import { TourDefinition } from './tour.types';

/**
 * Show the demo dialer and hide the real one
 */
const showDemoDialer = (phase: string) => () => {
  // Hide real dialer
  const realDialer = document.querySelector('[data-tour="dialer-widget"]') as HTMLElement;
  if (realDialer) realDialer.style.display = 'none';
  const realMinBtn = document.querySelector('[data-tour="dialer-minimized-button"]') as HTMLElement;
  if (realMinBtn) realMinBtn.style.display = 'none';

  // Signal demo component to show + set phase
  // Use a small delay so the demo renders before the spotlight looks for it
  window.dispatchEvent(new CustomEvent('dialer-tour-demo', { detail: { visible: true, phase } }));
};

/**
 * Hide demo dialer and restore real one
 */
const hideDemoDialer = () => {
  window.dispatchEvent(new CustomEvent('dialer-tour-demo', { detail: { visible: false } }));

  const realDialer = document.querySelector('[data-tour="dialer-widget"]:not([data-demo])') as HTMLElement;
  if (realDialer) realDialer.style.display = '';
  const realMinBtn = document.querySelector('[data-tour="dialer-minimized-button"]') as HTMLElement;
  if (realMinBtn) realMinBtn.style.display = '';
};

export const dialerTour: TourDefinition = {
  id: 'dialer-tour',
  name: 'All-in-One Dialer',
  page: '/leads',
  version: 12,
  nextTourId: 'communication-tour',
  steps: [
    // === STEP 1: INTRO — show queue ===
    {
      id: 'dialer-intro',
      targetSelector: '[data-tour="dialer-demo-widget"]',
      title: 'Your All-in-One Dialer',
      description: 'This is your calling hub — make browser-based calls, manage queues, and log everything to your CRM. Let\'s walk through each mode.',
      placement: 'left',
      onShow: showDemoDialer('idle'),
    },

    // === STEP 2: POWER DIALER ===
    {
      id: 'power-dialer',
      targetSelector: '[data-tour="dialer-demo-widget"]',
      title: 'Power Dialer — Sequential Calling',
      description: 'Calls leads one-by-one automatically. Watch: the first lead goes to voicemail and it auto-advances. The second lead answers — you\'re connected with full controls.',
      placement: 'left',
      onShow: showDemoDialer('power-intro'),
    },

    // === STEP 4: MULTI-LINE DIALER ===
    {
      id: 'multiline-dialer',
      targetSelector: '[data-tour="dialer-demo-widget"]',
      title: 'Multi-Line — 4 Calls at Once',
      description: 'Dials up to 4 leads simultaneously. The first person to answer gets connected to you — the rest are dropped. Maximum efficiency for high-volume outreach.',
      placement: 'left',
      onShow: showDemoDialer('multi-intro'),
    },

    // === STEP 5: INSURABOT KEY GRABBER ===
    {
      id: 'insura-bot',
      targetSelector: '[data-tour="dialer-demo-widget"]',
      title: 'InsuraBot — Secure Info Collection',
      description: 'During a call, switch to the InsuraBot tab to securely collect SSN, policy numbers, and more. The customer enters digits via keypad — watch them appear in real-time and auto-format.',
      placement: 'left',
      onShow: showDemoDialer('bot-intro'),
      onNext: hideDemoDialer,
    },
  ],
};
